var map = {
	"./en": [
		6744,
		6744
	],
	"./en.json": [
		6744,
		6744
	],
	"./es": [
		9921,
		9921
	],
	"./es.json": [
		9921,
		9921
	],
	"./fr": [
		9843,
		9843
	],
	"./fr.json": [
		9843,
		9843
	],
	"./pt-BR": [
		170,
		170
	],
	"./pt-BR.json": [
		170,
		170
	],
	"./zh-CN": [
		707,
		707
	],
	"./zh-CN.json": [
		707,
		707
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9823;
module.exports = webpackAsyncContext;